import React from "react";
import SearchSelectBox from "../SearchSelectBox";
import { PositionAchieved, positionAchievedNaming } from "../../api/typesDc";
import { useTranslation } from "react-i18next";

const PositionAcheivedSelect = (props:any) => {
    const { value, manageSelect, variant, isError, errorMessage, isReadOnly } = props;
    const [t] = useTranslation();
    const options = [
    { value: PositionAchieved.PA_WINNER, name: t(positionAchievedNaming[PositionAchieved.PA_WINNER]) },
    { value: PositionAchieved.PA_SEMI_FINAL, name: t(positionAchievedNaming[PositionAchieved.PA_SEMI_FINAL]) },
    { value: PositionAchieved.PA_QUARTER_FINAL, name: t(positionAchievedNaming[PositionAchieved.PA_QUARTER_FINAL]) },
    { value: PositionAchieved.PA_LAST_16, name: t(positionAchievedNaming[PositionAchieved.PA_LAST_16]) },
    { value: PositionAchieved.PA_GROUP, name: t(positionAchievedNaming[PositionAchieved.PA_GROUP]) },
    { value: PositionAchieved.PA_2ND, name: t(positionAchievedNaming[PositionAchieved.PA_2ND]) },
    { value: PositionAchieved.PA_3RD, name: t(positionAchievedNaming[PositionAchieved.PA_3RD]) },
    { value: PositionAchieved.PA_4TH, name: t(positionAchievedNaming[PositionAchieved.PA_4TH]) },
    { value: PositionAchieved.PA_5TH, name: t(positionAchievedNaming[PositionAchieved.PA_5TH]) },
    { value: PositionAchieved.PA_6TH, name: t(positionAchievedNaming[PositionAchieved.PA_6TH]) },
    { value: PositionAchieved.PA_7TH, name: t(positionAchievedNaming[PositionAchieved.PA_7TH]) },
    { value: PositionAchieved.PA_8TH, name: t(positionAchievedNaming[PositionAchieved.PA_8TH]) },
    { value: PositionAchieved.PA_9TH, name: t(positionAchievedNaming[PositionAchieved.PA_9TH]) },
    { value: PositionAchieved.PA_10TH, name: t(positionAchievedNaming[PositionAchieved.PA_10TH]) },
    { value: PositionAchieved.PA_11TH, name: t(positionAchievedNaming[PositionAchieved.PA_11TH]) },
    { value: PositionAchieved.PA_12TH, name: t(positionAchievedNaming[PositionAchieved.PA_12TH]) },
    { value: PositionAchieved.PA_13TH, name: t(positionAchievedNaming[PositionAchieved.PA_13TH]) },
    { value: PositionAchieved.PA_14TH, name: t(positionAchievedNaming[PositionAchieved.PA_14TH]) },
    { value: PositionAchieved.PA_15TH, name: t(positionAchievedNaming[PositionAchieved.PA_15TH]) },
    { value: PositionAchieved.PA_16TH, name: t(positionAchievedNaming[PositionAchieved.PA_16TH]) },
    { value: PositionAchieved.PA_17TH, name: t(positionAchievedNaming[PositionAchieved.PA_17TH]) },
    { value: PositionAchieved.PA_18TH, name: t(positionAchievedNaming[PositionAchieved.PA_18TH]) },
    { value: PositionAchieved.PA_19TH, name: t(positionAchievedNaming[PositionAchieved.PA_19TH]) },
    { value: PositionAchieved.PA_20TH, name: t(positionAchievedNaming[PositionAchieved.PA_20TH]) },
    { value: PositionAchieved.PA_21ST, name: t(positionAchievedNaming[PositionAchieved.PA_21ST]) },
    { value: PositionAchieved.PA_22ND, name: t(positionAchievedNaming[PositionAchieved.PA_22ND]) },
    { value: PositionAchieved.PA_23RD, name: t(positionAchievedNaming[PositionAchieved.PA_23RD]) },
    { value: PositionAchieved.PA_24TH, name: t(positionAchievedNaming[PositionAchieved.PA_24TH]) },
    { value: PositionAchieved.PA_25TH, name: t(positionAchievedNaming[PositionAchieved.PA_25TH]) },
    { value: PositionAchieved.PA_26TH, name: t(positionAchievedNaming[PositionAchieved.PA_26TH]) },
    { value: PositionAchieved.PA_27TH, name: t(positionAchievedNaming[PositionAchieved.PA_27TH]) },
    { value: PositionAchieved.PA_28TH, name: t(positionAchievedNaming[PositionAchieved.PA_28TH]) },
    { value: PositionAchieved.PA_29TH, name: t(positionAchievedNaming[PositionAchieved.PA_29TH]) },
    { value: PositionAchieved.PA_30TH, name: t(positionAchievedNaming[PositionAchieved.PA_30TH]) },
  ];

    return (
        <>
            <SearchSelectBox
            options={options}
            selectedValue={value}
            manageSelect={(e:any) => {manageSelect(e.value)}}
            label={''}
            variant={variant}
            isError={isError && !isReadOnly}
            errorMessage={errorMessage}
            disabled={isReadOnly}
            />
        </>
    );
}

export default PositionAcheivedSelect;